import React from 'react';
import WName, {WArticle} from '../WName';
import Eon, {EonArticle} from '../Eon';
import PL from '../problems/ProblemLink';
import QL from '../faq/QuestionLink';
import LRL from '../longreads/LongReadLink';
import OML from '../ormaybe/OrMaybeLink';
import AL from './AngleLink';
import NW from '../neologisms/NewWord';
import {E1, E2, Qual} from '../common';

// Haste is the straitjacket of consciousness.
export const straitjacket = {
  name: "straitjacket",
  alternatives: "haste,rushing",
  prelude: <span>
    If <PL>fear</PL> is the <QL>consciousness</QL>-killer, then <i>haste</i> is…?
  </span>,
  header: <span>
    Haste is the ‘straitjacket’ of consciousness.
  </span>,
  outside: <span>
    Rushing rushing rushing rushing can’t <i>think</i> rushing rushing rushing rushing can’t <i>think</i> rushing rushing rushing rushing can’t <i>think</i> rushing rushing…
  </span>,
  preview: <div className="angle-preview">
    <p>It’s a problem with the (necessarily) <AL>limited</AL> <NW>co-fo</NW> of the <QL>human</QL> <NW>khet</NW>. It’s a problem that – if the <PL>Individual</PL><sup>(®)</sup> is the <PL name="substance">be-all and end-all</PL> – is, frankly, ‘insurmountable’ (cf. the ‘<LRL name="nepantla.">Pratty Contrapositive</LRL>’).</p>
    <p><QL>Time</QL>. <WName cap /> can (<Qual.maybe />) <E2 /> it through the <QL>metaphor</QL> of <AL>Barbie and Ken</AL>.</p>
  </div>,
  text: <div className="angle-text">
    <p>[Under construction, if the <OML name="offensive">eejit</OML> <NW>zyzzyvas</NW> ever make <i><QL>time</QL></i> for it.]</p>
  </div>,
};

